import ShopPaymentPagingResultModelBase from '../_generated/modelBases/shop-payment-paging-result-model-base';

export default class ShopPaymentPagingResultModel extends ShopPaymentPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
